import VueSelector from './weekSelect.vue'

const selector = {}
selector.install = function (Vue) {
  Vue.component('vant-weekly-select', VueSelector)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(selector)
}

export default selector
